import constants from './const';

export const resizePatch = (parent, child, updateZoom) => {

    /* Check need patch */
    if (parent.clientWidth === child.clientWidth) {
        return;
    }
    
    console.log(`Before Patch: ${parent.clientWidth} ${child.clientWidth}`);
    const defaultZoom = constants.zoom;
    const num = defaultZoom * child.clientWidth;
    const preferZoom = num / parent.clientWidth;
    constants.zoom = preferZoom;
    updateZoom();
    console.log(`After Patch: ${parent.clientWidth} ${child.clientWidth}`);
};
